export const USD_DECIMALS = 18;
export const FUNDING_RATE_DECIMALS = 18;
export const POSITION_DECIMALS = 18; // Position size decimals
export const OI_DECIMALS = 18; // open interest decimals
export const DEFAULT_DECIMALS = 18;
export const PAIR_AMOUNT_DECIMALS = 10;
export const GENERIC_DISPLAY_DECIMALS = 6;
export const HOLDING_RATE_DECIMALS = 12;
export const LP_DECIMALS = 18;
// when storing percentage in contract
export const PERCENTAGE_DECIMALS = 4;
export const FUNDING_RATE_DISPLAY_DECIMALS = 4;
